lmApp
  .controller('VerimatrixController', ['$scope', '$rootScope', '$timeout', 'DrmService', 'ToastService', 'ValidatorService',
    function ($scope, $rootScope, $timeout, DrmService, ToastService, ValidatorService) {
      $scope.loading = false;
      $scope.verimatrixData = {};
      $scope.verimatrixMessages = [];
      $scope.validateErrors = {};
      $scope.selectedNode = {};

      var _validate = function (data) {
        var error = {};

        if (!data.serverAddress) error.serverAddress = true;
        if (!data.port || !ValidatorService.Numerical(data.port)) error.port = true;
        if (!data.keyReqTimeout || !ValidatorService.Numerical(data.keyReqTimeout)) error.keyReqTimeout = true;
        if (!data.httpApiPass) error.httpApiPass = true;
        if (data.httpApiPass !== data.httpApiConfirm) error.httpApiConfirm = true;

        $scope.validateErrors = error;
        return error;
      };

      $scope.getVerimatrixData = function () {

        $scope.loading = true;
        $rootScope.showLinearProgress('#verimatrixDrmLoader');
        $timeout(function () {
          $scope.verimatrixData = DrmService.GetVerimatrix();

          if ($scope.verimatrixData.nodes.length) $scope.selectedNode = $scope.verimatrixData.nodes[0];

          $scope.loading = false;
          $rootScope.hideLinearProgress('#verimatrixDrmLoader');
        }, 1000);
      };

      $scope.saveVerimatrixSettings = function () {
        if ($scope.loading) return;

        if (!_.isEmpty(_validate($scope.verimatrixData))) return;

        DrmService.SaveVerimatrix($scope.verimatrixData);
        ToastService.Small({
          title: 'Verimatrix settings successfully saved',
          color: 'green',
          icon: 'security-network',
          blocked: true
        }, 1000 * 3);
      };

      $scope.addNode = function () {
        if ($scope.loading) return;

        ToastService.Small({
          title: 'No new nodes found. Check VCAS OMI config first',
          color: 'amber',
          icon: 'server-off',
          blocked: true
        }, 1000 * 3);
      };

      $scope.removeNode = function () {
        if ($scope.loading) return;

        ToastService.Small({
          title: 'Cant remove. Check VCAS OMI config first',
          color: 'amber',
          icon: 'server-off',
          blocked: true
        }, 1000 * 3);
      };

      $scope.isNodeSelected = function () {
        return !_.isEmpty($scope.selectedNode);
      };

      $scope.selectNode = function (index) {
        $scope.selectedNode = $scope.verimatrixData.nodes[index];
      };

      $scope.verimatrixMessages = [
        ['0x0000', 'DVB reserved'],
        ['0x0001', 'Channel set-up'],
        ['0x0002', 'Channeljest'],
        ['0x0003', 'Channel_status'],
        ['0x0004', 'Channel_close'],
        ['0x0005', 'Channel error'],
        ['0x0006', 'DVB reserved'],
        ['0x0011', 'Channel set-up'],
        ['0x0012', 'Channel test'],
        ['0x0013', 'Channel_status'],
        ['0x0014', 'Channel close'],
        ['0x0015', 'Channel_error'],
        ['0x0016', 'DVB reserved'],
        ['0x0101', 'Stream set-up'],
        ['0x0102', 'Stream test'],
        ['0x0103', 'Stream status'],
        ['0x0104', 'Stream_close_request'],
        ['0x0105', 'Stream_close_response'],
        ['0x0106', 'Stream_error'],
        ['0x107 ', 'DVB reserved'],
        ['0x0111', 'Stream_set-up'],
        ['0x0112', 'Stream test'],
        ['0x0113', 'Stream status'],
        ['0x0114', 'Stream_close_request'],
        ['0x0115', 'Stream_close_response'],
        ['0x0116', 'Stream_error'],
        ['0x0117', 'Stream BW request'],
        ['0x0118', 'Stream BW allocation'],
        ['0x0119', 'DVB reserved	DVB reserved'],
        ['0x0201', 'CW provision'],
        ['0x0202', 'ECM response'],
        ['0x0203', 'DVB reserved	DVB reserved'],
        ['0x0211', 'data_provision'],
        ['0x0212', 'DVB reserved	DVB reserved'],
        ['0x0221', 'DVB reserved	DVB reserved'],
        ['0x8000', 'User defined	User defined']
      ];

      $scope.getVerimatrixData();
    }
  ]);